import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=17d9f906&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=ts&"
export * from "./ServiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=17d9f906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d9f906",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,IconsCheckmark16px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark16px.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,MoleculesCmsCustomButtonWrapper: require('/var/www/packages/theme/components/molecules/CmsCustomButtonWrapper.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
